// ประตูหน้า Setting — ต้องเป็น Agency Intelligence Admin
//
// เป็นแค่การจัดหน้าจอ ไม่ใช่การกันสิทธิ์: ต่อให้ผู้ใช้แก้ค่าใน storage จนผ่านหน้านี้มาได้
// ทุก API ที่แก้ข้อมูลก็ยังตอบ 403 อยู่ดี (server/middleware/require-admin.ts)
import type { ReactNode } from "react";
import { Link } from "react-router";
import { useAppSelector } from "@/app/hooks";
import { Topbar } from "@features/navigation/components/topbar";
import { NO_ACCESS, isRestricted } from "../lib/roles";
import { RequireSession } from "./require-session";

export function RequireAdmin({ children }: { children: ReactNode }) {
  const session = useAppSelector((s) => s.session.current);

  if (session && isRestricted(session)) {
    return (
      <>
        <Topbar />
        <main className="page">
          <div className="container">
            <NoAccess>
              <Link className="btn-primary inline-btn" to="/">
                กลับไป My Job
              </Link>
            </NoAccess>
          </div>
        </main>
      </>
    );
  }

  return <RequireSession>{children}</RequireSession>;
}

/**
 * กล่องแจ้งว่าสิทธิ์ไม่ถึง — ใช้ร่วมกันทุกที่ที่ผู้ใช้ชนกำแพงสิทธิ์
 * ข้อความต้องเป็นอันเดียวกันเสมอ ไม่งั้นคนเจอคนละหน้าจะคิดว่าเป็นคนละปัญหา
 */
export function NoAccess({ children }: { children?: ReactNode }) {
  return (
    <div className="panel empty-state">
      <h3>{NO_ACCESS}</h3>
      <p className="muted">ติดต่อผู้ดูแลระบบเพื่อขอสิทธิ์เข้าใช้งาน</p>
      {children}
    </div>
  );
}
